"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyDataIntegrationAttachmentEachFileMaxSizeInMib = exports.StudyDataIntegrationAttachmentUploadFileMaxSizeInMib = exports.StudyCommentMessageMaxLen = exports.IpCodeDescriptionMaxLen = exports.IpCodeLotNoMaxLen = exports.IpCodeMaxLen = exports.IpInfoWeightMax = exports.IpInfoIdMaxLen = exports.IpInfoNameMaxLen = exports.IpCategoryIdMaxLen = exports.IpCategoryNameMaxLen = exports.RandomizationRandomGroupCodeMaxLen = exports.RandomizationRandomGroupLabelMaxLen = exports.RandomizationStratificationCodeMaxLen = exports.RandomizationStratificationLabelMaxLen = exports.RandomizationStraticifaionCodeMaxLen = exports.RandomizationStraticifaionLabelMaxLen = exports.AttachmentMaxLen = exports.FileChecksumMaxLen = exports.FileSizeMaxLen = exports.FileNameMaxLen = exports.SignatureMaxLen = exports.IntegerMaxLen = exports.TextDefaultMaxLen = exports.DecimalMaxLen = exports.EdcFoldableTableRowValueForUnStriked = exports.EdcFoldableTableRowValueForStriked = exports.EdcFoldableTableRowStrikeAttrKeySuffix = exports.EdcFoldableTableRowCount = exports.EdcAttachmentBucketDelimiter = exports.EdcAttachmentAttributeDelimiter = exports.EdcAppendableTableRowValueForUnStriked = exports.EdcAppendableTableRowValueForStriked = exports.EdcAppendableTableRowStrikeAttrKeySuffix = exports.EdcAppendableTableRowCount = exports.EdcAttrKeySuffixDelimiter = exports.EdcGroupId = exports.PreGroupId = exports.InitialCrfPageSequence = exports.InitialItemSequence = exports.InitialVisitSequence = exports.DummyEdcCommon = void 0;
exports.DummyEdcCommon = "DummyEdcCommon";
exports.InitialVisitSequence = 1;
exports.InitialItemSequence = 1;
exports.InitialCrfPageSequence = 1;
exports.PreGroupId = "PRE";
exports.EdcGroupId = "EDC";
exports.EdcAttrKeySuffixDelimiter = "$$";
exports.EdcAppendableTableRowCount = "CUNT";
exports.EdcAppendableTableRowStrikeAttrKeySuffix = "STRK";
exports.EdcAppendableTableRowValueForStriked = 1;
exports.EdcAppendableTableRowValueForUnStriked = 0;
exports.EdcAttachmentAttributeDelimiter = "|"; // FILENAME|CHECKSUM|FILESIZE
exports.EdcAttachmentBucketDelimiter = ":"; // BUCKET:KEY
exports.EdcFoldableTableRowCount = "CUNT";
exports.EdcFoldableTableRowStrikeAttrKeySuffix = "STRK";
exports.EdcFoldableTableRowValueForStriked = 1;
exports.EdcFoldableTableRowValueForUnStriked = 0;
exports.DecimalMaxLen = 65;
exports.TextDefaultMaxLen = 1024;
exports.IntegerMaxLen = 10;
exports.SignatureMaxLen = 256;
exports.FileNameMaxLen = 255;
exports.FileSizeMaxLen = 16; // 1,000,000,000,000,000 = 1TB
exports.FileChecksumMaxLen = 32;
exports.AttachmentMaxLen = 1024;
// TODO, 아래 2개 상수 오타 제거 필요
exports.RandomizationStraticifaionLabelMaxLen = 255;
exports.RandomizationStraticifaionCodeMaxLen = 16;
exports.RandomizationStratificationLabelMaxLen = 255;
exports.RandomizationStratificationCodeMaxLen = 16;
exports.RandomizationRandomGroupLabelMaxLen = 255;
exports.RandomizationRandomGroupCodeMaxLen = 16;
// IPM
exports.IpCategoryNameMaxLen = 255;
exports.IpCategoryIdMaxLen = 32;
exports.IpInfoNameMaxLen = 255;
exports.IpInfoIdMaxLen = 32;
exports.IpInfoWeightMax = 10000;
exports.IpCodeMaxLen = 64;
exports.IpCodeLotNoMaxLen = 255;
exports.IpCodeDescriptionMaxLen = 255;
// Study Comment
exports.StudyCommentMessageMaxLen = 1023;
// Study Data Integration Attachment
exports.StudyDataIntegrationAttachmentUploadFileMaxSizeInMib = 1024;
exports.StudyDataIntegrationAttachmentEachFileMaxSizeInMib = 50;
//# sourceMappingURL=common.js.map